module.exports = __webpack_public_path__ + "static/img/menu2.a363ead4.png";